/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ConfigurazioneFormTemplateDTO } from '../model/models';
import { ConfigurazioneFormTranslateResponseDTO } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface PutTipoPraticaConfigurazioneFormEsercenteRequestParams {
    id: string;
    configurazioneFormTemplateDTO: ConfigurazioneFormTemplateDTO;
}

export interface TranslateTipoPraticaConfigurazioneFormEsercenteRequestParams {
    id: string;
}


export interface TipoPraticaConfigurazioneFormEsercenteServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Salva il template di form esercente di un bando dopo validazione strutturale (sintassi $dynamic, profondita\&#39; max, params).
     * 
     * @endpoint put /api/v1/gestione/tipi-pratica/{id}/configurazione-form-esercente
* @param requestParameters
     */
    putTipoPraticaConfigurazioneFormEsercente(requestParameters: PutTipoPraticaConfigurazioneFormEsercenteRequestParams, extraHttpRequestParams?: any): Observable<ConfigurazioneFormTemplateDTO>;

    /**
     * Dry-run del resolver sul template esercente: ritorna l\&#39;output atteso + warning per i $dynamic che producono 0 nodi.
     * 
     * @endpoint post /api/v1/gestione/tipi-pratica/{id}/configurazione-form-esercente/translate
* @param requestParameters
     */
    translateTipoPraticaConfigurazioneFormEsercente(requestParameters: TranslateTipoPraticaConfigurazioneFormEsercenteRequestParams, extraHttpRequestParams?: any): Observable<ConfigurazioneFormTranslateResponseDTO>;

}
